//fake types (to remove)

export interface TaxReportSummary {
    taxableIncome: {
        privateDisposals: number; // "Einkünfte aus privaten Veräußerungsgeschäften"
        capitalGains: {
            // "Einkünfte aus Kapitalvermögen"
            marginGains: number; // "Gewinne aus Margin, Derivate, Futures"
            marginLosses: number; // "Verluste aus Margin, Derivate, Futures"
        };
        otherIncome: number; // "Sonstige Einkünfte"
    };
    nonTaxableIncome: {
        privateDisposals: number; // "Nicht steuerbare Einkünfte aus privaten Veräußerungsgeschäften"
        otherIncome: number; // "Nicht steuerbare sonstige Einkünfte"
    };
    otherTransactions: {
        receivedDonations: number; // "Eingegangene Spenden und Schenkungen"
        sentDonations: number; // "Ausgegangene Spenden und Schenkungen"
        lostCoins: number; // "Verlorene und gestohlene Coins"
        mining: number; // "Mining (gewerblich)"
        minting: number; // "Minting"
    };
}

export interface TransactionStats {
    totalTransactions: number;
    costBasisMissingTotalPrice: number;
    costBasisCount: number;
    missingAssetValueCount: number;
    allTimeTotalTransactions: number;
}

//real types

export enum TaxReportFormat {
    PDF = 'application/pdf',
    EXCEL = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}
